import {DocTimestamp, MissingType} from "../extra";
import {UserInterface} from "../user";
import {StudentCvInterface} from "./cv";

export interface StudentInterface extends UserInterface {
    email: string,
    name?: string,
    birthday?: DocTimestamp;
    city?: string;
    invitedBySchool?: string;
    invitedByCompany?: string;
    invitedByRm?: string;
    description?: string;
    follows?: StudentFollowMapInterface;
    games?: {
        created: Date;
        id: string;
        rmId: string;
    }[];
    gender?: "male" | "female" | "other";
    genderId?: number;
    interestScopes?: number[];
    photoUrl?: string;
    studyScope?: number;
    website?: string;
    wins?: {
        created: Date;
        gameId: string;
        rmId: string;
    }[];
    bounded?: boolean;
    qrspFamilyIds?: number[];
    qrspFamilyRatings?: { number: number };
    fywPDF?: string;
    phone?: string;
}

export interface StudentFollowMapInterface {
    [key: string]: StudentFollowValueInterface;
}

export interface StudentFollowValueInterface {
    created: DocTimestamp;
    rmId: string;
    completionEmailSent?: boolean;
}

export interface StudentFormI {
    name: string;
    surname: string;
    description: string;
    birthday: Date | null;
    gender: "male" | "female" | "other";
    city: string;
    website: string;
    studyScope: number;
    interestScopes: number[];
    photo?: MissingType;
}

export interface FullStudentI {
    profile: StudentInterface,
    cv: StudentCvInterface
}

export const getNameAndSurname = (fullName: string) => {
    const split = fullName.split("_");
    const name = split?.[0] || "";
    const surname = split?.[1] || "";
    return {name, surname};
};

export const getNameAndSurnameString = (fullName: string | undefined) => {
    if (!fullName) return "";

    const split = fullName.split("_");
    const name = split?.[0] || "";
    const surname = split?.[1] || "";
    return `${name} ${surname}`;
};
